module.exports = __webpack_public_path__ + "static/img/SMSscenario2.15b2c65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/SMSscenario2.png
// module id = tysR
// module chunks = 0